import { ChemicalComponent } from "@/services/chemical-component"
import { Modal, ModalProps } from "antd"
import { createRoot } from "react-dom/client"
import styles from "./index.module.less";
import classNames from "classnames"
import { useState } from "react"
import Editor from '@monaco-editor/react'



interface CreateWithJsonModalProps extends ModalProps {
  onSuccess?: () => void
  component?: ChemicalComponent.Modal
  orgId?: number
}

export const CreateWithJsonModal = (props: CreateWithJsonModalProps) => {
  const {onCancel, onSuccess, orgId} = props
  const [value, setValue] = useState('')

  const toCreate = (values) => {
    if (orgId) {
      return ChemicalComponent.OrganizationService.create(orgId, values)
    }
    return ChemicalComponent.AdminService.create(values)
  }


  const onSave = async () => {
    try {
      const objVal = JSON.parse(value)
      delete objVal.id
      await toCreate(objVal)

      onSuccess?.()
    } catch(e) {

    }
  }

  return <Modal
    width={1200}
    open={true}
    maskClosable={false}
    onCancel={onCancel}
    onOk={onSave}
  >
    <Editor height='250px' defaultLanguage='json' defaultValue={value} onChange={(val) => setValue(val || '')} />
  </Modal>
}

CreateWithJsonModal.show = (props: CreateWithJsonModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<CreateWithJsonModal
    {...props}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
  />);
}